import * as Yup from 'yup'


export let schema = Yup.object({
    street: Yup.string().required(),
    area: Yup.string().required(),
    floor: Yup.string()
        .required()
        .matches(/^\d+$/, 'Floor must be a number')
        .test('is-positive', 'Floor must be a positive number', value => {
            return value ? parseInt(value) > 0 : false;
        }),
    city: Yup.string().required(),
    government: Yup.string().required(),
    buildingNo: Yup.string().required(),
    apartmentNo: Yup.string()
        .required()
        .matches(/^\d+$/, 'Apartment number must be a number')
        .test('is-positive', 'Apartment number must be a positive number', value => {
            return value ? parseInt(value) > 0 : false;
        }),
    others: Yup.string().nullable(), // Allow 'others' to be null
    name: Yup.string().required(),
    email: Yup.string().email().nullable(),
    category: Yup.string().required(),
    phone: Yup.string()
        .matches(/^(010|011|012|015)\d{8}$/, 'Phone number must start with 010, 011, 012, or 015 and contain exactly 11 digits')
        .required(),
    password: Yup.string().required(),
    business_activity: Yup.string().when('category', (category, schema) => {
        return typeof category === 'string' && category === 'busniess' ?
            schema.required('This field is required when the specific option is selected') :
            schema.nullable();
    }),
    // arrivalTime: Yup.string().required(),
    // arrivalDate: Yup.string().required()
    // .matches(/^(010|011|012|015)\d{8}$/, 'Phone number must start with 010, 011, 012, or 015 and contain exactly 11 digits')
    // .notRequired(), // Making phoneNumber_2 optional
});